import { LocationCoordinates } from '~/types';

export const getCoordinatesLink = (
  coordinates: LocationCoordinates,
  zoom = 10,
) =>
  `https://maps.google.com/?q=${coordinates.x},${coordinates.y}&ll=${coordinates.x},${coordinates.y}&z=${zoom}`;
